import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion } from "@/components/ui/accordion";
import { Button } from '@/components/ui/button';
import { HelpCircle, MessageSquare } from 'lucide-react';
import { faqData } from '@/lib/faqData';
import { FaqItem } from '@/components/faq/FaqItem';
import SEO from '@/components/seo/SEO';

const FaqPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background font-sans">
      <SEO title="FAQ - LendLifted" description="Common questions about LendLifted financing checkout for small sellers." />
      
      {/* Header */}
      <div className="border-b border-slate-200 bg-[#f8f5ef] py-24 text-center">
        <div className="container px-6">
           <div className="mb-8 inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
             <HelpCircle size={32} className="text-slate-800" />
           </div>
           <h1 className="mb-6 font-sans text-5xl tracking-tight text-slate-900 md:text-6xl">Help Center</h1>
           <p className="mx-auto max-w-2xl text-xl text-slate-600">
             Answers to common setup, billing, and buyer checkout questions.
           </p>
        </div>
      </div>

      {/* FAQ List */}
      <div className="container px-6 py-20 max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full space-y-6">
          {faqData.map((faq, index) => (
            <FaqItem key={index} item={faq} index={index} />
          ))}
        </Accordion>
      </div>

      {/* Contact CTA */}
      <div className="container px-6 pb-32 text-center">
        <div className="relative mx-auto max-w-4xl overflow-hidden rounded-[2rem] bg-slate-950 p-12 text-white shadow-2xl">
          <div className="pointer-events-none absolute right-0 top-0 h-64 w-64 -translate-y-1/2 translate-x-1/2 rounded-full bg-slate-800 opacity-50 blur-3xl"></div>
          <div className="relative z-10">
              <h3 className="text-3xl font-sans mb-4">Still have questions?</h3>
              <p className="mb-8 mx-auto max-w-lg text-slate-300">We're here to help. Our support team usually responds within 24 hours.</p>
              <Button size="lg" className="h-12 gap-2 rounded-full border-none bg-white px-8 text-slate-900 hover:bg-slate-100" asChild>
                <Link to="/contact">
                  <MessageSquare size={18} /> Contact Support
                </Link>
              </Button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default FaqPage;
